require("social/photos/photos_display.scss");
import { connect } from "react-redux";

import { Link } from "react-router-dom";

var StudentDisplay = require("components/users/students/StudentDisplay");
var Spinner = require("components/utility/Spinner");

var OwlShopActions = require("lib/actions/OwlShopActions");
var OwlShopSelectors = require("lib/selectors/OwlShopSelectors");

var OwlShopRouting = require("lib/routing/OwlShopRouting");

var CurrentUser = require("lib/account/CurrentUser");

const PER_PAGE = 12;

@connect(
	(state, props) => {

		var photographs = props.isClass ? OwlShopSelectors.photographs({state, conditions: { userIDs: props.ids }}) : OwlShopSelectors.photographs({state, conditions: { studentListIDs: props.ids }})

		return {
			loading: OwlShopSelectors.isLoadingPhotographs({ state }),
			photographs: photographs
		}
	},

	(dispatch, props) => ({
		populateData: (page) => {
			var conditions = props.isClass ? { userIDs: props.ids } : { studentListIDs: props.ids }

			return dispatch(OwlShopActions.fetchPhotographs({
				conditions: conditions,
				page: (page || 1),
				query: { per_page: PER_PAGE }
			}))
		}
	})
)

class PhotosDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			doneScrolling: false
		};

		this.wrapperRef = React.createRef();
	}

	//render 3 sample photos for the empty state
	renderEmptyState() {
		var img_paths = [require("empty-owlstagram/summer-owl.png"),
		require("empty-owlstagram/winter-owl.png"),
		require("empty-owlstagram/late-owl.png")]
		return (
			img_paths.map(path => {
				return (
					<div className="photoBox" key={path}>
						<div className="clearfix textHeader">
							<div className="pull-left">
								Name
							</div>
							<div className="pull-right">
								Date
							</div>
						</div>
						<img className="photo samplePhoto" src={path} />
					</div>
				)
			})
		)
	}

	renderPhotos() {
		var photos = _.sortBy(this.props.photographs, "id").reverse().map(photo => {
			return (
				<div className="photoBox" key={photo.id}>
					<div className="clearfix textHeader">
						<div className="pull-left">
							<StudentDisplay studentID={photo.user_id} />
						</div>
						<div className="pull-right">
							{$wr.formatDate(photo.created_at)}
						</div>
					</div>
					<img className="photo" src={photo.url} />
				</div>
			)
		})
		return photos
	}

	nextPage() {
		return Math.floor(this.props.photographs.length / PER_PAGE) + 1;
	}

	render() {
		var photos = this.renderPhotos()
		if (this.props.loading) {
			var spinner = (<Spinner scale={2.0} placeholder={true} />);
		} else if (!photos.length) {
			var user = CurrentUser.get()
			var samplePhotos = this.renderEmptyState()

			//text and sample photos for empty state
			var zeroState = (
				<div className="text-center">
					<p className="zeroHeader">
						No one has taken any photos yet for your class Owlstagram.
						{!user.is_admin ?
							<p><Link to={OwlShopRouting.getPath({ activeView: OwlShopRouting.VIEWS.PHOTOS })}>
								Take the first photo!
							</Link></p>
							:
							<p><a href = "https://whooosreading.zendesk.com/hc/en-us/articles/360060957752-Owlstagram">
								Learn more about Owlstagram here!
							</a></p>
						}
					</p>
					{samplePhotos}
				</div>
			);
		}

		return (
			<div className="photosDisplay" ref={this.wrapperRef}>
				{spinner}
				{zeroState}
				<div className="photos">
					{photos}
				</div>
			</div>
		);
	}

	checkScroll() {
		if (!this.props.loading && !this.state.doneScrolling) {
			var $wrapper = $(this.wrapperRef.current);
			var threshold = 50//300;
			var lim = $wrapper.offset().top + $wrapper.height();
			var loc = $(window).scrollTop() + $(window).height();

			if (loc + threshold > lim) {
				this.props.populateData(this.nextPage()).then((response) => {
					if (response.photographs.length < PER_PAGE) {
						this.setState({ doneScrolling: true });
					}
				})
			}
		}
	}

	componentDidMount() {
		this.props.populateData();
		$(window).scroll(this.checkScroll);
	}

	componentWillUnmount() {
		$(window).off("scroll", this.checkScroll);
	}

};

PhotosDisplay.WrappedComponent.propTypes = StrictPropTypes({
	//students: PropTypes.array.isRequired,
	isClass: PropTypes.bool,
	ids: PropTypes.array.isRequired,

	// @connect data
	photographs: PropTypes.array.isRequired,
	loading: PropTypes.bool,

	// @connect handler
	populateData: PropTypes.func
});

module.exports = PhotosDisplay;



// WEBPACK FOOTER //
// ./modules/components/social/photos/PhotosDisplay.js